function PlanGroupProdClassCell(props) {
    return (
        <>
            {props.value?.product_h10?.map((obj) => obj.label).join(",") ?? "-"}
        </>
    );
}

export default PlanGroupProdClassCell;
